import { createContext, useContext } from 'react';


export const ProcessContext = createContext(null);
export const useProcessContext = () => useContext(ProcessContext);
